import React from "react";
import {
  Grid,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { Edit, Description } from "@mui/icons-material";
import {
  CardContainer,
  formatPrice,
  FullWidthCard,
  KeyValueRow,
} from "../../../rcAutoDetails2/tabs/preventivi";

const PersonaCard = ({ preventivo, onModifica }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid item>
      <CardContainer
        color={preventivo?.color || "407ad6"}
        mb={4}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile && "center",
        }}
      >
        {/* Badge del tipo di servizio */}
        {preventivo?.badge && (
          <Chip
            sx={{
              backgroundColor: `#${preventivo?.color || "407ad6"}`,
              color: "white",
              fontSize: 16,
              width: "100%",
            }}
            label={preventivo.badge}
          />
        )}

        <FullWidthCard>
          {/* Left Section - Logo/Icona */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            pt={2}
            sx={{
              minWidth: "220px",
              flexBasis: isMobile ? "100%" : "15%",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mb={1}
              px={1}
            >
              {preventivo.tipoServizio}
            </Typography>

            <Description
              sx={{
                width: 80,
                height: 80,
                color: `#${preventivo?.color || "407ad6"}`,
                marginBottom: 1,
              }}
            />
          </Box>

          {/* Center Section - Dettagli */}
          <CardContent
            sx={{
              flexGrow: 1,
              padding: 2,
              flexBasis: isMobile ? "100%" : "70%",
            }}
          >
            {Object.entries(preventivo.dettagli || {})
              .filter(([_, v]) => v !== "" && v !== null && v !== undefined)
              .map(([key, value], id) => (
                <KeyValueRow key={id} isEven={id % 2 === 0}>
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    fontWeight="bold"
                    textAlign="right"
                  >
                    {key}:
                  </Typography>
                  <Typography variant="body2" textAlign="right">
                    {value || "-"}
                  </Typography>
                </KeyValueRow>
              ))}
          </CardContent>

          {/* Right Section - Prezzo e Azioni */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            pt={1}
            pb={2}
            px={2}
            sx={{
              minWidth: "180px",
              flexBasis: isMobile ? "100%" : "15%",
              borderLeft: !isMobile && "1px solid #e0e0e0",
            }}
          >
            {/* Prezzo */}
            <Box textAlign="center" mb={2}>
              <Typography variant="caption" color="textSecondary">
                Prezzo stimato
              </Typography>
              <Typography
                variant="h5"
                fontWeight="bold"
                color="primary"
                mt={0.5}
              >
                {preventivo.prezzo ? formatPrice(preventivo.prezzo) : "N/D"}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {preventivo.frequenza || "al mese"}
              </Typography>
            </Box>

            {/* Pulsante Modifica */}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<Edit />}
              onClick={onModifica}
              sx={{ mb: 1 }}
            >
              Modifica dati
            </Button>

            {/* Info aggiuntive */}
            {preventivo.note && (
              <Typography
                variant="caption"
                color="textSecondary"
                textAlign="center"
                sx={{ mt: 1 }}
              >
                {preventivo.note}
              </Typography>
            )}
          </Box>
        </FullWidthCard>
      </CardContainer>
    </Grid>
  );
};

export default PersonaCard;
